import { z } from 'zod';

export const ZipCode = z
  .string()
  .regex(/^\d{5}/)
  .min(5)
  .max(5);

export type ZipCode = z.infer<typeof ZipCode>;
